export function cn(...classes: (string | undefined | null | false)[]) {
  return classes.filter(Boolean).join(' ');
}

export const formatCurrency = (val?: number) => {
  if (val === undefined || val === null) return '-';
  const formatted = new Intl.NumberFormat('it-IT', { 
    maximumFractionDigits: 0 
  }).format(val);
  return `€ ${formatted}`;
};

export const formatDate = (isoString: string) => {
  const date = new Date(isoString);
  return new Intl.DateTimeFormat('it-IT', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
};

export const formatDuration = (seconds: number) => {
  const min = Math.floor(seconds / 60);
  const sec = seconds % 60;
  return `${min}m ${sec < 10 ? '0' : ''}${sec}s`;
};